<h3>Ajustes do Plano de trabalho:</h3>
<hr>
<div class="col-md-12">

  <button class="btn btn-app" pTooltip="Listar" tooltipPosition="top" [routerLink]="['listar']"
    routerLinkActive="btn-app-active">
    <i class="fa fa-list"></i> Listar
  </button>

  <button class="btn btn-app" pTooltip="Novo" *ngIf="podeAdd" tooltipPosition="top" routerLinkActive="btn-app-active"
    [routerLink]="['cadastrar']">
    <i class="fa fa-plus"></i> Cadastrar
  </button>
  <button class="btn btn-app" pTooltip="Novo" *ngIf="!podeAdd" tooltipPosition="top" routerLinkActive="btn-app-active"
    (click)="setaMsgNaoPode()">
    <i class="fa fa-plus"></i> Cadastrar
  </button>
  <hr>
</div>

<div>
  <router-outlet></router-outlet>
</div>